<script setup lang="ts">
import MoonIcon from 'assets/images/svg/icon/moon.svg';
import SunIcon from 'assets/images/svg/icon/sun.svg';
import { computed } from 'vue';

import { useNuxtApp } from '#app';
import { useColorMode } from '#imports';

type Props = {
    isMobile?: boolean;
};

defineProps<Props>();

const colorMode = useColorMode();

const isDarkTheme = computed({
    get: () => colorMode.preference === 'dark-mode',
    set: (newValue) => {
        colorMode.preference = newValue
            ? 'dark-mode'
            : 'light-mode';
    }
});

function toggleTheme() {
    isDarkTheme.value = !isDarkTheme.value;
}

</script>

<template>
  <button type="button"
          aria-label="Change theme"
          :title="isDarkTheme ? 'Select light theme' : 'Select dark theme'"
          :class="[
            'btn-switch cursor-pointer display-flex justify-center align-items-center border-500 btn-hover',
            { 'mobile-switch': isMobile }
          ]"
          @click="toggleTheme"
  >
    <component :is="isDarkTheme ? SunIcon : MoonIcon"
               class="icon"
    />
    <span v-if="isMobile"
          class="compact-500-accent"
    >
      {{ isDarkTheme ? 'Dark' : 'Light' }}
    </span>
  </button>
</template>

<style scoped lang="scss">
.btn-switch {
  width: 52px;
  height: 52px;
  background: transparent;
}

.mobile-switch {
  display: flex;
  align-items: center;
  width: auto;
  height: auto;
  padding: 0;
  background: transparent;
  color: var(--content-primary);
  gap: 8px;
}
</style>
